import { useEffect } from "react";
import { useQuery } from "react-query";
import { getGameBusinessMenuList } from "src/api/commonApi";
import { useAppSelector } from "src/redux/redux-hooks";
import { BusinessMenuI } from "src/types/types";

const useBusinessMenu = ({ enabled }: { enabled: boolean }) => {
  const { isLoggedIn } = useAppSelector((state) => state.user);

  const { data, refetch } = useQuery<BusinessMenuI[]>({
    enabled: false,
    queryKey: ["BusinessMenu"],
    queryFn: () => getGameBusinessMenuList(),
  });

  useEffect(() => {
    if (enabled && isLoggedIn) {
      refetch();
    }
  }, [enabled, isLoggedIn]);

  return {
    data,
    refetch,
  };
};

export default useBusinessMenu;
